import { useTranslation } from 'react-i18next';

export const useModuleTranslation = () => useTranslation(['claim_info', 'commons']);
